<template>
	<div class="notification-bar">
		<font-awesome-icon :icon="icon" class="icon" />
		<div v-if="message" class="message">{{ message }}</div>
		<slot class="slot" />
	</div>
</template>

<script>
export default {
	name: 'NotificationBar',
	props: {
		icon: Array,
		message: String,
	},
};
</script>

<style lang="scss" scoped>
.notification-bar {
	display: flex;
	min-height: 44px;
	align-items: center;
	background-color: $border-color-light;
	@include rem('border-radius', 6px);
	border: 1px solid $b360-color--gray__darker;
}

.icon {
	@include rem('margin', 1px 12px 0 12px);
}

.slot,
.message {
	font-weight: 500;
	padding: 0;
	margin: 0;
}
</style>
